import { Link } from 'react-router-dom';
import { categories } from '@/mocks/manga';

export default function Footer() {
  return (
    <footer className="mt-16 bg-foreground-900 text-foreground-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-14 sm:grid-cols-2 md:px-6 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-book-open-line text-lg"></i>
            </span>
            <span className="text-xl font-bold text-background-50">日漫屋</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-foreground-300">
            聚合日漫字幕组最新译制资源，提供日漫简体、繁体及双语对照阅读。热门连载同步翻译，点开即选版本，追更不迷路。
          </p>
          <div className="mt-5 flex items-center gap-3 text-foreground-300">
            <a href="#" rel="nofollow" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" rel="nofollow" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors">
              <i className="ri-bilibili-line"></i>
            </a>
            <a href="#" rel="nofollow" aria-label="QQ" className="flex h-9 w-9 items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors">
              <i className="ri-qq-line"></i>
            </a>
          </div>
        </div>

        <nav aria-label="漫画分类">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-background-50">漫画分类</h3>
          <ul className="mt-4 grid grid-cols-2 gap-2 text-sm text-foreground-300">
            {categories.map((c) => (
              <li key={c.id}>
                <Link to={`/category/${c.id}`} className="hover:text-primary-400 transition-colors">
                  {c.name}漫画
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="快速导航">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-background-50">快速导航</h3>
          <ul className="mt-4 space-y-2 text-sm text-foreground-300">
            <li>
              <Link to="/" className="hover:text-primary-400 transition-colors">
                首页
              </Link>
            </li>
            <li>
              <Link to="/category/0" className="hover:text-primary-400 transition-colors">
                全部漫画
              </Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-primary-400 transition-colors">
                关于我们
              </Link>
            </li>
          </ul>
        </nav>

        <div>
          <h3 className="text-sm font-semibold uppercase tracking-wider text-background-50">联系与合作</h3>
          <ul className="mt-4 space-y-2 text-sm text-foreground-300">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line"></i> contact@rimangwu.example
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-chat-3-line"></i> 字幕组合作：tg@rimangwu
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-copyright-line"></i> 版权合作与授权说明
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-400 sm:flex-row md:px-6">
          <p>© 2026 日漫屋 · 日漫汉化在线看，仅用于学习交流，请支持正版。</p>
          <p className="flex items-center gap-1">
            <i className="ri-heart-3-line text-primary-500"></i> 让每一部好漫画被看见
          </p>
        </div>
      </div>
    </footer>
  );
}